import React, { Component } from 'react';
import { Container } from 'reactstrap';
import SubHeader from './periodical_subheader';
import StatusView from './status_view';
import { connect } from 'react-redux';
import SchedulingModel from 'shared/components/Models/scheduling_model';
import CalendarView from '../CalenderView/index';
import simpleReactValidator from 'simple-react-validator';

import { FaFastForward } from 'react-icons/lib/fa';

class PeriodicalStatus extends Component {
    constructor(props) {
        super(props)
        this.validator = new simpleReactValidator();
        this.state = {
            group_data: [{id:"1",name:"Group1"},{id:"2",name:"Group2"},{id:"3",name:"Group3"},{id:"4",name:"Group4"},{id:"5",name:"Group5"}],
            rSelected:1,
            modal: false,
        }
        this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
        this.toggle = this.toggle.bind(this);
        this.onSubmit=this.onSubmit.bind(this);
    }

  

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    onRadioBtnClick(e){
        this.setState({ rSelected:e.target.value });
    }

    onSubmit(){
        var that=this;
    
          if( that.validator.fieldValid("frequency") && that.validator.fieldValid("accurence_count") && that.validator.fieldValid("start_date") && that.validator.fieldValid("end_date") && that.validator.fieldValid("allocate_to") && that.validator.fieldValid("status") )
          {
            console.log("submit click");
          }
          else
          {
            that.validator.showMessages();
            that.forceUpdate();
          }
      }

    render() {
        var contractdata = [{ id: "1", name: "Contract1", group_id: "1" }, { id: "2", name: "Contract2", group_id: "1" }];
        
        var facilitydata = [{ id: "1", name: "Facility1", contract_id: "1" }, { id: "2", name: "Faclity2", contract_id: "1" }, { id: "3", name: "Facility3", contract_id: "1" }, { id: "4", name: "Facility4", contract_id: "1" }, { id: "5", name: "Facility5", contract_id: "1" }];        
        
        const PeriodicData = [
            { id: '1', name: 'Bathroom floor' },
            { id: '2', name: 'Full window clean' },
            { id: '3', name: 'Lounge chairs   ' },
            { id: '4', name: 'Dining room Chairs' },
            { id: '5', name: 'High level Cleaning' },
            { id: '6', name: 'Vacant room clean' },
            { id: '7', name: 'Carpet steam cleaning' },
            { id: '8', name: 'Ceiling fans cleaning' },
            { id: '9', name: 'Floor scrubbing' },
            { id: '10', name: 'Courtyard' }
        ];

        const YearList=[
            {id:'1',month_name:'Jul',year:'2017'},
            {id:'2',month_name:'Aug',year:'2017'},
            {id:'3',month_name:'Sep',year:'2017'},
            {id:'4',month_name:'Oct',year:'2017'},
            {id:'5',month_name:'Nov',year:'2017'},
            {id:'6',month_name:'Dec',year:'2017'},
            {id:'7',month_name:'Jan',year:'2018'},
            {id:'8',month_name:'Feb',year:'2018'},
            {id:'9',month_name:'Mar',year:'2018'},
            {id:'10',month_name:'Apr',year:'2018'},
            {id:'11',month_name:'May',year:'2018'},
            {id:'12',month_name:'Jun',year:'2018'},
            {id:'13',month_name:'Jul',year:'2018'},
            {id:'14',month_name:'Aug',year:'2018'},
            {id:'15',month_name:'Sep',year:'2018'},
            {id:'16',month_name:'Oct',year:'2018'},
            {id:'17',month_name:'Nov',year:'2018'},
            {id:'18',month_name:'Dec',year:'2018'},
            
        ]
        var daily_data = [
            { name: 'Everyday', id: 0 },
            { name: 'Every Weekday', id: 1 }
        ];

        var weekly_data = [
            { name: 'Monday', id: 1 },
            { name: 'Tuesday', id: 2 },
            { name: 'Wednesday', id: 3 },
            { name: 'Thursday', id: 4 },
            { name: 'Friday', id: 5 },
            { name: 'Saturday', id: 6 },
            { name: 'Sunday', id: 0 }
        ];
        var numbers_data = [
            { name: '1', id: '1' },
            { name: '2', id: '2' },
            { name: '3', id: '3' },
            { name: '4', id: '4' },
            { name: '5', id: '5' },
            { name: '6', id: '6' },
            { name: '7', id: '7' },
            { name: '8', id: '8' },
            { name: '9', id: '9' },
            { name: '10', id: '10' },
        ];

        var quarterly_data = [{ name: 3, id: 3 },
        { name: 6, id: 6 },
        { name: 9, id: 9 },
        ]

        var yearly_data = [
            { name: 'January', id: 1 },
            { name: 'February', id: 2 },
            { name: 'March', id: 3 },
            { name: 'April', id: 4 },
            { name: 'May', id: 5 },
            { name: 'June', id: 6 },
            { name: 'July', id: 7 },
            { name: 'August', id: 8 },
            { name: 'September', id: 9 },
            { name: 'October', id: 10 },
            { name: 'November', id: 11 },
            { name: 'December', id: 12 },
        ];

        var frequency_data = [{ id: "1", name: "Daily" }, { id: "2", name: "Weekly" }, { id: "3", name: "Monthly" }, { id: "4", name: "Quarterly" }];

        var charge_data = [{ id: "1", name: "Hourly" }, { id: "2", name: "Fixed" }];
        var status_data = [{ id: "1", name: "Active" }, { id: "2", name: "Pending" }];
        var reporting_type = [{ id: "1", name: "Number" }, { id: "2", name: "Date" }];

        var allocate_to_data = [{ id: "1", name: "Jolly Shah" }, { id: "2", name: "Avani Panchani" }, { id: "3", name: "Shailesh Kant" }, { id: "4", name: "Sunil Shreepal" }, { id: "5", name: "Ashish Maru" }];
        var user_data = [{ id: "1", name: "FS" }, { id: "2", name: "AL" },{ id: "3", name: "BL" }];

        var sceduling_data=[{ id: "1", frequency: "",accurence_count:"",start_date:"",end_date:"",allocate_to:"",status:"" }];

        return ( <Container fluid = {true} >
                    <SubHeader group_data = {this.state.group_data} contractdata = {contractdata} facilitydata = {facilitydata} onRadioBtnClick={this.onRadioBtnClick} rSelected={this.state.rSelected}/>
                          {this.state.rSelected==1?<CalendarView year={YearList} toggle={this.toggle}/> : <StatusView toggle={this.toggle}/>}

                            {/* <SchedulingModel isOpen={this.state.modal}
                            toggle={this.toggle}
                            frequency_data={frequency_data}
                            daily_data={daily_data}
                            weekly_data={weekly_data}
                            allocate_to_data={allocate_to_data}
                            numbers_data={numbers_data}
                            quarterly_data={quarterly_data}
                            yearly_data={yearly_data}
                            charge_data={charge_data}
                            status_data={status_data}
                            reporting_type={reporting_type}
                            oncheck={this.onCheck}
                            charged_show={this.state.charged_show}
                            className={"modal-lg"} sceduling_data={sceduling_data} validator={this.validator} onSubmitClick={this.onSubmit}
                            /> */}
            </Container >
        )
    }
}

const AppContainer = connect(

)(PeriodicalStatus);

export default AppContainer;


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalStatus/index.js